import {SimplePresentation, SimplePresentationRunner} from "../SimplePresentationRunner";
import {NormalStop} from "./NormalStop";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";


export class Result implements FlowStatePresentation {
    private _presentations: SimplePresentation[];

    constructor() {
        this._presentations = [
            //new BingeSpinStop(),
            new NormalStop(),

        ]

    }

    public start(flowStateController: FlowStateController) {
        SimplePresentationRunner.run(this._presentations, () => flowStateController.finish(), (callback?: Function) => flowStateController.setSkipCallback(callback), "ResultPresentation ");
    }
}